import angular from 'angular';
import { EMPLOYER_WORKFLOW_STATUS } from '../constants/employer-workflow';

export const EmployerWorkflowStepResolver = (WorkflowService, PositionService, EmployerService, EmployerFeedbackService) => {
    const getPositionFeedbackNonRatedCount = (position) => {
        const { nonRated } = EmployerFeedbackService.getFeedbackWorkflowCounters(position);

        return nonRated;
    };

    const getPositionStatusCounter = (table, workflowStatus) => {
        const counter = table.find(({ status }) => status === workflowStatus);

        if (!counter) {
            return 0;
        }

        return counter.count;
    };

    const getPositionCounters = (position) => {
        const { table = [] } = position;
        const totalPositionsCount = position.numOfPositions;
        const feedbackNonRatedCount = getPositionFeedbackNonRatedCount(position);
        const reviewedCount = getPositionStatusCounter(table, EMPLOYER_WORKFLOW_STATUS.REVIEWED);
        const interviewedCount = getPositionStatusCounter(table, EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT);
        const hiredCount = getPositionStatusCounter(table, EMPLOYER_WORKFLOW_STATUS.HIRED);
        const contactCount = getPositionStatusCounter(table, EMPLOYER_WORKFLOW_STATUS.CONTACT);

        return {
            totalPositionsCount,
            feedbackNonRatedCount,
            contactCount,
            reviewedCount,
            interviewedCount,
            hiredCount,
        };
    };

    const getPosition = async (positionId, employerId) => {
        const { result: [positionWorkflowCountersData] } = await EmployerService.getEmployerWorkflowCounters(employerId, {
            positionIDs: [positionId],
        });
        const { result: position } = await PositionService.getPosition(positionId);

        return {
            ...position,
            table: (positionWorkflowCountersData && positionWorkflowCountersData.table) || [],
        };
    };

    const getWorkflowStep = async (positionId, employerId) => {
        const position = await getPosition(positionId, employerId);
        const {
            contactCount,
            reviewedCount,
            interviewedCount,
            hiredCount,
            feedbackNonRatedCount,
        } = getPositionCounters(position);

        if (feedbackNonRatedCount) {
            return EMPLOYER_WORKFLOW_STATUS.FEEDBACK;
        }

        if (contactCount) {
            return EMPLOYER_WORKFLOW_STATUS.CONTACT;
        }

        if (reviewedCount) {
            return EMPLOYER_WORKFLOW_STATUS.REVIEWED;
        }

        if (interviewedCount) {
            return EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT;
        }

        if (hiredCount) {
            return EMPLOYER_WORKFLOW_STATUS.HIRED;
        }

        return EMPLOYER_WORKFLOW_STATUS.FEEDBACK;
    };

    return {
        getWorkflowStep,
    };
};

angular.module('TALENYA-FE').factory('EmployerWorkflowStepResolver', EmployerWorkflowStepResolver);
